import React, { useEffect, useState } from "react";
import Loader from "components/Common/loader";
import "./TableContainer.css";

function TruncatedText({ text, maxLength }) {
  const [isHovered, setIsHovered] = useState(false);
  const isTruncated = text?.length > maxLength;
  const truncatedText = isTruncated ? text?.slice(0, maxLength) + "..." : text;

  return (
    <div
      className="truncated-text-wrapper"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <span className="truncated-text">{truncatedText}</span>
      {isHovered && isTruncated && <div className="tooltip">{text}</div>}
    </div>
  );
}

function TableContainer({
  headerGroups,
  getTableBodyProps,
  rows,
  getTableProps,
  prepareRow,
  isLoading = false,
  getRowProps = () => ({}),
  totalRecords,
  tableData,
  isPatientReportColor = false,
}) {
  const [showAllColumns, setShowAllColumns] = useState(false);

  const toggleShowColumns = () => {
    setShowAllColumns(!showAllColumns);
  };
  // const getNestedValue = (obj, path) => {
  //   return path.split('.').reduce((acc, key) => acc && acc[key], obj);
  // };
  const columnsToTruncate = [
    // "investigation_code",
    // "investigation_name",
    "template_description",
    "observation",
    "panel_name",
    "franchise_name",
    "patient_name",
    "panel_code",
    "investigation_type",
    // "patient_obj.patient_name",
    "patient_name",
    "branch_address",
    "message",
    "address",
    "document_name",
    "franchise_code",
    "company_name",
    "remark",
    "lab_department",
    // "observation_name",
    "comments",
    "test_name",
    "state",
    // "franchise_obj.franchise_code",
    // "franchise_obj.company_name",
    // "investigation_obj.investigation_name",
    // "franchise_obj.address",
    // "package_obj.package_name",
    // "investigation_obj.investigation_name",
  ];

  const headerFullForms = {
    PP: "Purchase Price",
    SP: "Selling Price",
    QIn: "Quantity In",
    QOut: "Quantity Out",
    TC: "Total Cost",
    TQB: "Total Quantity Balance",
  };

  const SPECIAL_HEADER_PAIRS = [
    ["Employee Name", "Branch"],
    ["Investigation/Test Name", "Investigation/Test Code"],
    ["Investigation/Test Name", "Investigation Alias"],
    ["Investigation/Test Name", "Reporting"],
    ["Doctor Name", "Degree"],
    ["Patient Name", "Registration Number"],
    ["Zone Name", "Mobile Number"],
    ["Role Name", "Description"],
    ["Department", "Department Code"],
  ];

  const isSpecialHeaderSignature = (headers = []) => {
    return SPECIAL_HEADER_PAIRS.some(
      ([thirdHeader, fourthHeader]) =>
        headers[2]?.Header === thirdHeader && headers[3]?.Header === fourthHeader
    );
  };

  useEffect(() => {
    const tooltipTriggerList = document.querySelectorAll(
      '[data-bs-toggle="tooltip"]'
    );
    tooltipTriggerList?.forEach((tooltip) => {
      new window.bootstrap.Tooltip(tooltip);
    });
  }, []);

  return (
    <>
      <div className="boxContent noPadding">
        <div className="contentScroll">
          {isLoading && <Loader isLoading={true} isFixed={false} />}
          <table
            {...getTableProps()}
            className={`table mb-0 table-hover ${
              headerGroups.some((headerGroup) =>
                headerGroup.headers.some((column) =>
                  Object.keys(headerFullForms).includes(column.Header)
                )
              )
                ? "table-bordered"
                : ""
            } ${
              headerGroups.some(
                (headerGroup) =>
                  headerGroup.headers[0]?.Header === "Observation Name" &&
                  headerGroup.headers[1]?.Header === "Value" &&
                  headerGroup.headers[2]?.Header === "Flag"
              )
                ? "observation-entry-table"
                : ""
            }`}
            style={
              headerGroups.some((headerGroup) =>
                headerGroup.headers.some((column) =>
                  Object.keys(headerFullForms).includes(column.Header)
                )
              )
                ? { border: "black" }
                : {}
            }
          >
            <thead>
              {headerGroups.map((headerGroup) => {
                const { key, ...headerGroupProps } =
                  headerGroup.getHeaderGroupProps();
                const isResultEntryObservationHeader =
                  headerGroup.headers[0]?.Header === "Observation Name" &&
                  headerGroup.headers[1]?.Header === "Value" &&
                  headerGroup.headers[2]?.Header === "Flag" &&
                  headerGroup.headers[3]?.Header === "MacReading" &&
                  headerGroup.headers[4]?.Header === "Unit" &&
                  headerGroup.headers[5]?.Header === "MinValue" &&
                  headerGroup.headers[6]?.Header === "MaxValue" &&
                  headerGroup.headers[7]?.Header === "Display Reading" &&
                  headerGroup.headers[8]?.Header === "Method";
                return (
                  <tr key={key} {...headerGroupProps}>
                    {headerGroup.headers
                      .filter((column, index) => {
                        const isSpecialHeader = isSpecialHeaderSignature(
                          headerGroup.headers
                        );

                        if (isResultEntryObservationHeader) {
                          return true;
                        }

                        // Always show TAT column regardless of View All toggle
                        if (column?.Header === "TAT") {
                          return true;
                        }

                        if (showAllColumns || (isSpecialHeader && index < 5)) {
                          return true;
                        } else if (!isSpecialHeader) {
                          return true;
                        }
                        return false;
                      })
                      .map((column) => {
                        const { key, ...cellProps } = column.getHeaderProps(
                          column.getSortByToggleProps()
                        );
                        const tooltipText = headerFullForms[column.Header];
                        return (
                          <th
                            key={key}
                            {...cellProps}
                            style={{
                              color: isResultEntryObservationHeader
                                ? "#387C44"
                                : "black",
                            }}
                          >
                            {tooltipText ? (
                              <span
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title={tooltipText}
                              >
                                {column.render("Header")}
                              </span>
                            ) : (
                              column.render("Header")
                            )}
                          </th>
                        );
                      })}
                    {isSpecialHeaderSignature(headerGroup.headers) && (
                      <th>
                        <button
                          className="btn btn-primary"
                          onClick={toggleShowColumns}
                        >
                          {showAllColumns ? "Hide" : "View All"}
                        </button>
                      </th>
                    )}
                  </tr>
                );
              })}
            </thead>
            <tbody {...getTableBodyProps()}>
              {rows.map((row, rowIndex) => {
                prepareRow(row);
                const rowProps = getRowProps(row.original) || {};
                const { key, ...restRowProps } = row.getRowProps();

                let rowBackgroundColor = "";
                if (isPatientReportColor) {
                  rowBackgroundColor =
                    rowIndex % 2 === 0 ? "#f5c9d0" : "#ffffff";
                } else {
                  rowBackgroundColor =
                    (row.original.inventory_type || "").replace("-", "_") ===
                    "STOCK_IN"
                      ? "#ededed"
                      : (row.original.inventory_type || "").replace(
                          "-",
                          "_"
                        ) === "STOCK_OUT"
                      ? "#f3e1f5"
                      : "";
                }

                return (
                  <tr
                    key={key}
                    {...restRowProps}
                    onClick={() => {
                      if (typeof rowProps.onClick === "function") {
                        rowProps.onClick();
                      }
                    }}
                  >
                    {row.cells
                      .filter((rowCell, index) => {
                        const isSpecialHeader = isSpecialHeaderSignature(
                          headerGroups[0]?.headers || []
                        );

                        // Always show TAT cell regardless of View All toggle
                        if (
                          rowCell?.column?.Header === "TAT" ||
                          rowCell?.column?.id === "tat" ||
                          rowCell?.column?.accessor === "tat"
                        ) {
                          return true;
                        }

                        if (
                          showAllColumns ||
                          (isSpecialHeader && index < 5) ||
                          rowCell?.column.id === "ids"
                        ) {
                          return true;
                        } else if (!isSpecialHeader) {
                          return true;
                        }
                        return false;
                      })
                      .map((rowCell) => {
                        const { key, ...cellProps } = rowCell.getCellProps();
                        return (
                          <td
                            key={key}
                            {...cellProps}
                            // style={{
                            //   backgroundColor:
                            //     (row.original.inventory_type || "").replace(
                            //       "-",
                            //       "_"
                            //     ) === "STOCK_IN"
                            //       ? "#ededed"
                            //       : (row.original.inventory_type || "").replace(
                            //           "-",
                            //           "_"
                            //         ) === "STOCK_OUT"
                            //       ? "#f3e1f5"
                            //       : "",
                            // }}
                            style={{
                              backgroundColor: rowBackgroundColor,
                            }}
                          >
                            {columnsToTruncate.includes(rowCell.column.id) ? (
                              <TruncatedText
                                text={row.original[rowCell.column.id]}
                                maxLength={23}
                              />
                            ) : (
                              rowCell.render("Cell")
                            )}
                          </td>
                        );
                      })}
                  </tr>
                );
              })}
            </tbody>
            {tableData?.length > 0 &&
              headerGroups.some((headerGroup) =>
                headerGroup.headers.some((column) =>
                  ["QIn", "QOut", "Profit", "Appointment Amount"].includes(
                    column.Header
                  )
                )
              ) && (
                <tfoot>
                  <tr>
                    <td
                      colSpan={5}
                      style={{ fontWeight: "bold", textAlign: "center" }}
                    >
                      TOTAL
                    </td>

                    {headerGroups[0]?.headers.slice(5).map((column) => {
                      let totalValue = 0;
                      if (
                        [
                          "QIn",
                          "QOut",
                          "Profit",
                          "Appointment Amount",
                        ].includes(column.Header)
                      ) {
                        totalValue = rows.reduce((sum, row) => {
                          const value = row.original[column.id];
                          return sum + (typeof value === "number" ? value : 0);
                        }, 0);
                      }

                      return (
                        <td key={column.id} style={{ fontWeight: "bold" }}>
                          {[
                            "QIn",
                            "QOut",
                            "Profit",
                            "Appointment Amount",
                          ].includes(column.Header)
                            ? totalValue
                            : ""}
                        </td>
                      );
                    })}
                  </tr>
                </tfoot>
              )}
          </table>
        </div>
      </div>
      {!isLoading && totalRecords === 0 && (
        <div className="noData">No data found</div>
      )}
      {!isLoading && tableData?.length === 0 && (
        <div className="noData">No data found</div>
      )}
    </>
  );
}

export default TableContainer;
